import { Button as AntdButton, type ButtonProps as AntdButtonProps } from 'antd'
import classNames from 'classnames'

import { useUserInfoStore } from '@/stores/user/userInfoStore'

import cn from './AtomButton.module.scss'

type ButtonProps = Omit<AntdButtonProps, 'type' | 'variant' | 'color'> & {
  variant?: 'primary' | 'secondary' | 'danger'
  fullWidth?: boolean
}

function AtomButton({
  className,
  variant = 'primary',
  fullWidth = false,
  ...props
}: ButtonProps) {
  const isOrganisationSelected = useUserInfoStore(
    (state) => Object.keys(state.selectedOrganisation).length > 0
  )

  return (
    <AntdButton
      {...props}
      className={classNames(
        cn.button,
        variant === 'secondary' && cn.secondary,
        variant === 'danger' && cn.danger,
        fullWidth && cn.fullWidth,
        props.shape === 'circle' && cn.circle,
        isOrganisationSelected && cn.accentSelected,
        className
      )}
    />
  )
}

export default AtomButton
